import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Drawer from 'material-ui/Drawer';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import MissingInfo from '../User/MissingInfo';
import SelectedShifts from './SelectedShifts';
import WeeklyCalendar from '../../containers/WeeklyCalendar';
import FilterSidebar from '../../containers/FilterSidebar';
import Preferences from '../../containers/Preferences';
import UberConnectModal from '../User/UberConnectModal';
import FilterButton from './FilterSidebar/FilterButton';
import Loading from '../shared/Loading';

import { m } from '../../utils';
import './index.css';

class Book extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDrawerOpen: true
    };
  }

  componentWillMount() {
    this.props.loadData();
  }

  toggleDrawer = () =>
    this.setState({ isDrawerOpen: !this.state.isDrawerOpen });

  book = () => {
    const {
      bookingDetail,
      bookings,
      cars = [],
      duration,
      tier,
      filteredParkinglots = [],
      filteredShifts = [],
      handleTierFilter,
      handleParkinglotFilter,
      handleStartTimeFilter,
      handleChangeDate,
      handleDurationFilter,
      loadAvailableShifts,
      isDoubleShift,
      parkinglots,
      removeFromSelectedShifts,
      selectedShifts,
      shifts,
      startTime,
      toggleShiftList,
      upcomingShift,
      openDialog,
      certification,
      email,
      uber_token,
      account_name,
      uber_password,
      clearSelectedShifts,
      week,
      token,
      bank_info
    } = this.props;
    const uberURL = `${
      process.env.REACT_APP_API_URL
    }/users/auth/uber?email=${encodeURIComponent(email)}`;
    const isMobile = window.innerWidth < 768;

    return (
      <Query
        query={gql`
          query vehicleAvailability(
            $tier: String!
            $startDate: DateTime!
          ) {
            vehicleAvailability(
              vehicleClass: $tier
              startDate: $startDate
            ) {
              startTime
              endTime
            }
          }
        `}
        variables={{ tier, startDate: m(week[0]).format() }}>
        {({ loading, error, data, refetch }) => {
          if (error) return <Redirect to="/404" />;
          if (loading) return <Loading size="3x" />;
          return (
            <div className="book-container">
              <Drawer
                className="drawer"
                open={this.state.isDrawerOpen}
                docked={!isMobile}
                containerStyle={{ zIndex: 2 }}
                overlayStyle={{ zIndex: 2 }}
                width={isMobile ? '90%' : '25%'}
                onRequestChange={isDrawerOpen => {
                  this.setState({ isDrawerOpen });
                }}>
                <FilterSidebar
                  certification={certification}
                  duration={duration}
                  tier={tier}
                  toggleDrawer={this.toggleDrawer}
                  filteredParkinglots={filteredParkinglots}
                  handleTierFilter={handleTierFilter}
                  handleChangeDate={handleChangeDate}
                  startDate={m(week[0])}
                  endDate={m(week[6])}
                  handleParkinglotFilter={handleParkinglotFilter}
                  handleDurationFilter={handleDurationFilter}
                  handleStartTimeFilter={handleStartTimeFilter}
                  parkinglots={parkinglots}
                  searchAvailableShifts={this.handleSearchAvailableShifts}
                  shifts={
                    certification === 'plus_demo' && tier === 'Plus'
                      ? shifts.filter(
                          shift => ![3, 7, 23].includes(shift.hour)
                        )
                      : shifts
                  }
                  startTime={startTime}
                  openDialog={openDialog}
                />
              </Drawer>

              <div className="book-body">
                <FilterButton onClick={this.toggleDrawer} />
                <div className="general-faq-header">
                  <h1>Book</h1>
                </div>
                <WeeklyCalendar
                  bookingDetail={bookingDetail}
                  bookings={bookings}
                  cars={cars}
                  duration={duration}
                  filteredShifts={filteredShifts.sort(
                    (a, b) => m(a.time).hour() - m(b.time).hour()
                  )}
                  isDoubleShift={isDoubleShift}
                  loadAvailableShifts={loadAvailableShifts}
                  selectedShifts={selectedShifts}
                  shifts={shifts}
                  startTime={startTime}
                  tier={tier}
                  toggleShiftList={toggleShiftList}
                  upcomingShift={upcomingShift}
                  vehicleAvailability={data.vehicleAvailability}
                  loading={loading}
                  error={error}
                  token={token}
                  refetchBookings={refetch}
                />
                <SelectedShifts
                  clearSelectedShifts={clearSelectedShifts}
                  openDialog={openDialog}
                  selectedShifts={selectedShifts}
                  removeFromSelectedShifts={removeFromSelectedShifts}
                  refetchBookings={refetch}
                />
              </div>
              <Preferences openIndex={0} />
              {!uber_token ? (
                <UberConnectModal
                  uberURL={uberURL}
                  username={account_name}
                  password={uber_password}
                />
              ) : null}
              {!bank_info && uber_token ? <MissingInfo /> : null}
            </div>
          );
        }}
      </Query>
    );
  };

  render() {
    const { loggedIn, status } = this.props;

    if (loggedIn && status === 'operating') {
      return this.book();
    }
    return <Redirect to="/dashboard" />;
  }
}

export default Book;



// WEBPACK FOOTER //
// ./src/components/Book/index.js